(function () {
  angular
    .module("akitabox.mobile.directives.qrScanner", [
      "bcQrReader",
      "ui.router",
      "akitabox.core.utils",
      "akitabox.core.services.flag",
      "akitabox.core.services.organization",
      "akitabox.core.services.qrcode",
      "akitabox.core.toast",
      "akitabox.ui.dialogs.qrCode",
    ])
    .directive("abmQrScanner", AbmQrScannerDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.backNav
   * @name AbmQrScannerDirective
   *
   * @restrict EA
   *
   * @description
   * `abm-qr-reader` can be used as an element or attribute directive
   * that will open a dialog and allow the user to scan a QR code
   *
   * @usage
   * <hljs lang="html">
   *
   * <abm-qr-reader></abm-qr-reader>
   *
   * <!-- OR -->
   *
   * <md-button class="md-icon-button" aria-label="Scan QR Code">
   *   <md-icon class="material-icons">add_photo</md-icon>
   * </md-button>
   *
   * </hljs>
   */
  function AbmQrScannerDirective(
    // Angular
    $q,
    $compile,
    $http,
    $templateCache,
    $location,
    $log,
    $window,
    // Third party
    $state,
    // Services
    media,
    OrganizationService,
    QRCodeService,
    ToastService,
    // Dialogs
    QrManualEntryDialog,
    QrPinSearchDialog,
    QrScannerDialog
  ) {
    return {
      restrict: "EA",
      link: postLink,
      scope: {},
    };

    function postLink($scope, $element) {
      var TAG_NAME = "ABM-QR-SCANNER";
      var templateUrl = "app/mobile/directives/qr-scanner/qr-scanner.html";

      // Check directive usage
      // If used as an element, replace content with back button (with abm-qr-scanner attribute)
      // If used as an attribute, add click event
      if ($element[0].tagName === TAG_NAME) {
        $http
          .get(templateUrl, { cache: $templateCache })
          .then(function (response) {
            if (response.status === 200) {
              $element.replaceWith($compile(response.data)($scope));
            } else {
              $log.error("<abm-qr-scanner> unable to retrieve template");
            }
          });
      } else {
        $element.on("click", onClick);
      }

      /**
       * If media is supported navigate to the scan QR code scanner (camera dialog)
       * If media is not supported, open the manual entry dialog
       */
      function onClick() {
        /**
         * Check if there are video devices and we have permissions to use them.
         * @return {Promise<Boolean>} True iff we can use a video device.
         */
        function checkVideoAccess() {
          if (!media.isSupported()) {
            return $q.resolve(false);
          }
          return media
            .getMedia(media.QR_SCANNER_CONSTRAINTS)
            .then(function (stream) {
              media.stopStream(stream);
              return true;
            })
            .catch(function () {
              return false;
            });
        }

        /**
         * Present the user with a QR code input.
         * @param {Boolean} useCamera - True to use the camera to scan a qr code.
         * @return {Promise<String>} The QR code's id.
         */
        function getQrCode(useCamera) {
          if (useCamera) {
            return QrScannerDialog.show({
              redirect: false,
              returnModel: true,
            });
          } else {
            return QrManualEntryDialog.show();
          }
        }

        function showPinSearchDialog(qrCode) {
          var options = { locals: { code: qrCode._code } };
          QrPinSearchDialog.show(options).then(function (pin) {
            $location.path("/m" + pin.uri);
            return pin;
          });
        }

        checkVideoAccess()
          .then(getQrCode)
          .then(function (qrCode) {
            if (qrCode.is_associated) {
              var organization = OrganizationService.getCurrent();
              var redirect = QRCodeService.parse(qrCode);
              if (redirect) {
                if (redirect.subdomain === organization.subdomain.key) {
                  $location.path(redirect.mobilePath);
                } else {
                  $window.location.href =
                    $location.protocol() + "://" + redirect.mobileUrl;
                }
                return redirect.model;
              }
              ToastService.showError("Unable to find QR Code");
            } else {
              return showPinSearchDialog(qrCode);
            }
          });
      }
    }
  }
})();
